import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Purchases/MaterialIssue/tables";
import headers from "../../../../Data/Tables/Purchases/MaterialIssue/headers";
import Status from "../../../../Componets/Status";
import toast from "react-hot-toast";
import ActionButton from "../../../../Componets/Buttons/action";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_material_issues } from "../../../../Controllers/Purchases/MaterialIssue";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";
import DotIcon from "../../../../Assets/Svg/dot";

const InventoryMaterialIssueTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const issues = await get_all_material_issues(data);
      if (issues?.status) {
        let data = [];

        issues?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/purchases/min/view/${value?._id}`,
            Number: `#ISSUE-${value?.number}`,
            Request: `#REQ-${value?.request?.number}`,
            Date: <DateTimeBadge date={value?.date} />,
            "Issue Date": <DateTimeBadge date={value?.issue_date} />,
            Amount: value?.total?.toFixed(3),
           /*  "Issue Status": value?.issued ? (
              <div className="flex">
                <div className={`my-auto pr-2 text-green-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Issued</div>
              </div>
            ) : (
              <div className="flex">
                <div className={`my-auto pr-2 text-yellow-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Pending</div>
              </div>
            ), */
            Status: <Status status={value?.status} />,
            Action: !value?.issued ? (
              <ActionButton
                edit={`/app/purchases/min/edit/${value?._id}`}
                id={value?._id}
                api="delete-material-issue"
                actiondata={actiondata}
                headers={header}
              />
            ) : null,
          });
        });

        setPagination({
          currentPage: issues?.data?.currentPage,
          totalCount: issues?.data?.totalCount,
          totalPages: issues?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(issues?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InventoryMaterialIssueTable;